import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { RootContext } from '../context/RootContext';
import { getFirstNavigation } from '../utils/RouteUtils/getFirstNavigation';

const PublicRoutes = () => {
  const { token, p_m__, sideMenu } = useContext(RootContext);
  if (!Array.isArray(p_m__)) {
    return <Outlet />;
  }

  const defaultFirstNav = getFirstNavigation(sideMenu);

  return token ? <Navigate to={defaultFirstNav} /> : <Outlet />;
};

export default PublicRoutes;
